<template>
  <!-- 内容组件外框 -->
  <div class="status-tag">
    <!-- 适用企业应用: -->
    <div v-for="item in list" class="tag" :key="item.agent_id">
      <!-- <i :class="[item.status == '2' ? 'off' : item.status == '3' ? 'await' : '']">
        {{ item.status == '1' ? '通过' : item.status == '2' ? '未通过' : '审核中' }}
      </i> -->
      <span>{{ item.agent_name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatusTag',
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      value1: [],
    };
  },
};
</script>

<style lang="scss" scoped>
.status-tag {
  display: flex;
  flex-wrap: wrap;
  padding: 12px 12px 0;
  .tag {
    margin: 0 16px 12px 0;
    span {
      font-size: 14px;
      color: #606266;
    }
    i {
      display: inline-block;
      border-radius: 2px;
      width: 42px;
      font-size: 12px;
      text-align: center;
      border-radius: 2px;
      color: #2f96ff;
      background: rgba(47, 150, 255, 0.08);
      padding: 3px 0;
      &.off {
        color: #ff602e;
        background: rgba(255, 96, 46, 0.08);
      }
      &.await {
        color: #c0c4cc;
        background: #f0f2f5;
      }
    }
  }
}
</style>
